function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import Types from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@wise/components-theming';
import { getItems, getButtonItems } from './items';
import Navigation from './Navigation';
import { LocaleValues, SupportedHomeLocales } from '../common/l10n';
import { LANGUAGES } from '../common/i18n';
import NavTypes from '../NavTypes';
import parseLanguage from '../common/i18n/parseLanguage';
import { PillNavigationProvider } from '../common/context/PillNavigation/PillNavigation';
var PublicNavigation = function PublicNavigation(_ref) {
  var inverse = _ref.inverse,
    languageProp = _ref.language,
    availableLanguages = _ref.availableLanguages,
    onLanguageChange = _ref.onLanguageChange,
    locale = _ref.locale,
    onLocaleChange = _ref.onLocaleChange,
    availableLocales = _ref.availableLocales,
    activePath = _ref.activePath,
    className = _ref.className,
    isUserLoggedIn = _ref.isUserLoggedIn,
    hasUserPreviouslyLoggedIn = _ref.hasUserPreviouslyLoggedIn,
    revealHiddenItemsList = _ref.revealHiddenItemsList,
    submenuItems = _ref.submenuItems,
    skipToContentHref = _ref.skipToContentHref,
    config = _ref.config,
    navType = _ref.navType,
    registerLink = _ref.registerLink,
    isTestEnvironment = _ref.isTestEnvironment,
    isPillNavigation = _ref.isPillNavigation,
    businessTabLink = _ref.businessTabLink,
    personalTabLink = _ref.personalTabLink,
    cta = _ref.cta,
    withCountrySelector = _ref.withCountrySelector;
  if (process.env.NODE_ENV !== 'production') {
    if (!skipToContentHref) throw new Error("\n      <PublicNavigation /> must be provided with a `skipToContentHref`.\n      See https://github.com/transferwise/public-navigation#skip-to-main-content-link\n    ");
  }
  var language = parseLanguage(languageProp);
  var homeLink = Object.values(SupportedHomeLocales).includes(locale) ? "/".concat(locale) : '/';
  var prevScroll = useRef();
  var handleScroll = function handleScroll(event) {
    var currentScroll = event.currentTarget.scrollY;
    if (currentScroll !== undefined && prevScroll.current > 1) {
      if (currentScroll < prevScroll.current) {
        setIsCTAshown(false);
        setIsScrolling(false);
      }
      if (currentScroll > prevScroll.current) {
        setIsCTAshown(true);
        setIsScrolling(true);
      }
    }
    prevScroll.current = currentScroll;
    return false;
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCTAshown = _useState2[0],
    setIsCTAshown = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isScrolling = _useState4[0],
    setIsScrolling = _useState4[1];
  React.useEffect(function () {
    if (isPillNavigation) {
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
    return undefined;
  }, [isPillNavigation]);
  var getPersonalTabLink = function getPersonalTabLink() {
    if (personalTabLink) {
      return personalTabLink;
    }
    if (isPillNavigation) {
      return '/:locale/account/';
    }
    return '/:localePath/';
  };
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PillNavigationProvider, {
    pillNavigation: isPillNavigation
  }, skipToContentHref && /*#__PURE__*/React.createElement("a", {
    href: skipToContentHref,
    className: "btn btn-primary tw-public-nav-btn-skip"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "public-navigation.skip-to-content"
  })), /*#__PURE__*/React.createElement(Navigation, {
    inverse: inverse,
    isTestEnvironment: isTestEnvironment,
    language: language,
    onLanguageChange: onLanguageChange,
    availableLanguages: availableLanguages,
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    items: getItems({
      locale: locale,
      isUserLoggedIn: isUserLoggedIn,
      hasUserPreviouslyLoggedIn: hasUserPreviouslyLoggedIn,
      revealHiddenItemsList: revealHiddenItemsList,
      items: config.items,
      registerLink: registerLink,
      isPillNavigation: isPillNavigation
    }),
    activePath: activePath,
    "data-tracking-id": "public-navigation",
    buttonItemsForNav: getItems({
      locale: locale,
      isUserLoggedIn: isUserLoggedIn,
      hasUserPreviouslyLoggedIn: hasUserPreviouslyLoggedIn,
      revealHiddenItemsList: revealHiddenItemsList,
      items: config.buttonItemsForNav,
      registerLink: registerLink,
      isPillNavigation: isPillNavigation
    }),
    commonItemsForNav: getItems({
      locale: locale,
      isUserLoggedIn: isUserLoggedIn,
      hasUserPreviouslyLoggedIn: hasUserPreviouslyLoggedIn,
      revealHiddenItemsList: revealHiddenItemsList,
      items: config.commonItemsForNav,
      registerLink: registerLink,
      isPillNavigation: isPillNavigation
    }),
    buttonItems: getButtonItems({
      locale: locale,
      isUserLoggedIn: isUserLoggedIn,
      hasUserPreviouslyLoggedIn: hasUserPreviouslyLoggedIn,
      items: config.buttonItems,
      registerLink: registerLink
    }),
    className: className,
    submenuItems: submenuItems,
    navType: navType,
    isPillNavigation: isPillNavigation,
    businessTabLink: businessTabLink,
    personalTabLink: getPersonalTabLink(),
    cta: cta,
    logoLink: homeLink,
    isCTAshown: isCTAshown && cta,
    isScrolling: isScrolling,
    isModern: isModern,
    withCountrySelector: withCountrySelector
  })));
};
PublicNavigation.defaultProps = {
  inverse: true,
  language: LANGUAGES.indexOf('en') > -1 ? 'en' : LANGUAGES[0],
  onLanguageChange: undefined,
  availableLanguages: undefined,
  locale: '',
  onLocaleChange: undefined,
  availableLocales: undefined,
  activePath: undefined,
  className: '',
  isUserLoggedIn: false,
  hasUserPreviouslyLoggedIn: false,
  revealHiddenItemsList: ['mca'],
  submenuItems: [],
  registerLink: '',
  isTestEnvironment: false,
  isPillNavigation: false,
  businessTabLink: '/:locale/business/',
  personalTabLink: undefined,
  cta: undefined,
  withCountrySelector: false
};
export default PublicNavigation;